import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const estimateApi = createApi({
  reducerPath: "estimateApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getAiEstimate: build.mutation({
      query: ({ kind, property, comps }) => ({
        url: "/estimate",
        method: "POST",
        body: { kind, property, comps },
      }),
    }),
  }),
});

export const { useGetAiEstimateMutation } = estimateApi;
